<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography">
  {{data.message}}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="true">Conferma</button>
  <button mat-button color="primary" mat-dialog-close>Annulla</button>
</mat-dialog-actions>
